"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStatusIndicatorBarModel = void 0;
var status_1 = require("../features/status");
var Accessor_1 = require("../models/Accessor");
var buildStatusIndicatorBarModel = function (definition, latestValue) {
    var _a;
    var statusFeature = (0, status_1.getStatusFeature)(definition.features);
    var status = (_a = (statusFeature && latestValue && (0, Accessor_1.accessorForReference)(statusFeature.status)(latestValue))) !== null && _a !== void 0 ? _a : status_1.ThresholdStatus.UNKNOWN;
    var color = latestValue ? (0, status_1.buildColorAccessor)(definition)(latestValue) : status_1.MetricsNeutralColor;
    return {
        color: color,
        status: status,
    };
};
exports.buildStatusIndicatorBarModel = buildStatusIndicatorBarModel;
//# sourceMappingURL=StatusIndicatorBarModel.js.map